import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, HostBinding, OnDestroy} from '@angular/core';
import { RealTimeContextService } from 'app/real-time/real-time-context.service';
import { InformoService } from 'app/cities/informo/informo.service';

@Component({
  selector: 'informo-navigation-tools',
  templateUrl: './navigation-tools.component.html',
  styleUrls: ['./navigation-tools.component.scss']
})
export class NavigationToolsComponent implements OnInit, OnDestroy {
  private visible: Boolean = false;
  @HostBinding('class.visible') navFormVisible = false;
  @Output() onStarting: EventEmitter<any> = new EventEmitter<any> ();
  @Output() onDestination: EventEmitter<any> = new EventEmitter<any> ();
  @Output() onBothFilled: EventEmitter<any> = new EventEmitter<any> ();
  @ViewChild('calculeRouteButton', { read: ElementRef }) calculeRouteButton: ElementRef;
  @ViewChild('starting', { read: ElementRef }) starting: ElementRef;
  @ViewChild('destination', { read: ElementRef }) destination: ElementRef;
  typingOrigin: string;
  typingDestination: string;
  shortest = false;

  public startingPoint: any;
  public destinationPoint: any;
  public searchTextStarting: string;
  public searchTextDestination: string;



  constructor(
    private realtimeContextService: RealTimeContextService,
    private informoService: InformoService
  ) {}

  ngOnInit() {
    document.querySelector('informo-real-time-legend').classList.add('navigation');
  }

  searchStarting() {
    this.searchTextStarting = this.typingOrigin;
    this.starting.nativeElement.classList.add('loading');
    this.informoService.searchGeocoding(this.searchTextStarting).toPromise().then((startingPoint) => {
      this.starting.nativeElement.classList.remove('loading');
      if (startingPoint) {
        this.starting.nativeElement.classList.add('fixed');
        this.startingPoint = startingPoint;
        this.onStarting.emit(startingPoint);
      }
    });
  }

  searchDestination(event?: KeyboardEvent) {
    this.searchTextDestination = this.typingDestination;
    this.destination.nativeElement.classList.add('loading');
    this.informoService.searchGeocoding(this.searchTextDestination).toPromise().then((destinationPoint) => {
      this.destination.nativeElement.classList.remove('loading');
      if (destinationPoint) {
        this.destination.nativeElement.classList.add('fixed');
        this.destinationPoint = destinationPoint;
        this.onDestination.emit(destinationPoint);
      }
    });
  }

  toggleNavigationForm() {
    this.navFormVisible = !this.navFormVisible;
  }

  clean(point) {
    this.calculeRouteButton.nativeElement.classList.remove('hidden');
    if (point === 'starting') {
      this.starting.nativeElement.classList.remove('fixed');
      this.typingOrigin = '';
      this.startingPoint = null;
      this.onStarting.emit(null)
    } else {
      this.destination.nativeElement.classList.remove('fixed');
      this.typingDestination = '';
      this.destinationPoint = null;
      this.onDestination.emit(null);
    }
  }

  checkIfBothAreFilled() {
    if (this.startingPoint && this.destinationPoint) {
      const params = {
        origin: this.startingPoint.features[0].properties.coords,
        destination: this.destinationPoint.features[0].properties.coords,
        shortest: this.shortest
      };
      this.calculeRouteButton.nativeElement.classList.add('loading');
      this.informoService.searchRoute(params).toPromise().then(
        route => {
          this.calculeRouteButton.nativeElement.classList.remove('loading');
          this.calculeRouteButton.nativeElement.classList.add('hidden');
          this.navFormVisible = false;
          this.onBothFilled.emit(route);
        }
      )
    }
  }

  toggleShortest() {
    this.shortest = !this.shortest;
    if (this.calculeRouteButton.nativeElement.classList.contains('hidden')) {
      this.checkIfBothAreFilled();
    }
  }

  ngOnDestroy() {
    document.querySelector('informo-real-time-legend').classList.remove('navigation');
  }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/navigation-tools/navigation-tools.component.ts